<template>
  <div
    class="body"
    style="background: radial-gradient(circle, rgba(45,46,47,1) 20%, rgba(111,142,148,1) 100%);padding:12% 35% 20% 35%;height: 100vh!important;"
  >
    <div class="vue-template">
      <form>
        <div class="form-group">
          <label>Телефон номер</label>
          <input
            type="text"
            ref="focused"
            v-model="code"
            class="form-control form-control-lg"
          />
        </div>

        <button
          type="button"
          class="btn btn-dark btn-lg btn-block"
          @click="Send()"
        >
          {{ $t("Сақлаш") }}
        </button>

        <!-- <p class="forgot-password text-right mt-2 mb-4"></p> -->
        <div class="end">
          <router-link :to="{ path: '/sendsms' }" style="color: blue!important;">
            {{ $t("ИД Ўзгартириш") }}
          </router-link>
        </div>
      </form>
    </div>
  </div>
</template>
<style>
.vue-template form {
  padding: 2% 8%;
  border-radius: 10px;
  background: white;
}

.vs__selected-options {
  max-width: 100% !important;
}
</style>

<script>
export default {
  data() {
    return {
      data: [],
      code:'+998',
      hostname:'',
      type:'client'
    };
  },
  created(){
  },
  methods: {
    Focus() {
      this.$refs.focused.focus();
    },
    Send() {
        let self = this;
      const username = self.data.username;
      const password = self.data.password;
      const token = Buffer.from(`${username}:${password}`, 'utf8').toString('base64')
      axios
        .get(self.data.url+"/getsecret_codes?Phone="+self.code,{
        headers: {
          'Authorization': `Basic ${token}`
        }})
        .then(function(response) {
          if(response.data.error==false){
            self.$router.push({ path: "/sendsms"});
          }else{
            self.$store.state.errors=response.data.message;
          }
        });
      } 
  },
  mounted() {
    let self=this;
    axios
        .get("https://bdm.uz/server/url")
        .then(function(response) {
          self.data = response.data;
        });
    self.Focus();
  }
};
</script>
